<template>
  <div>
    <div>

    </div>
    <button class="btn is-aitems-700 my-3 mx-3"
            @click.prevent="publish">
      Pubblica!
    </button>

    <section v-if="!isLever" class="w-4/5 mx-auto my-5 flex items-center">
      <label for="action">
        Meccanica:
      </label>
      <select name="action"
              id="action"
              v-model="selectedAction"
              class="ml-2 border-b border-black bg-gray-200 px-2 py-1"
              @change="updateAction"
      >
        <option :value="action.id_articolo"
                v-for="action in actions"
                v-text="action.descrizione"
        >
        </option>
      </select>
      <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
        </svg>
      </div>
    </section>

    <section class="w-4/5 table mx-auto rounded border shadow-lg">
      <div class="th tr">
        <div class="td">
          Nota
          <div class="flex flex-col justify-between pr-2 cursor-pointer">
            <div @click="orderBy()">
              <i class="fas fa-caret-up"></i>
            </div>
            <div @click="orderBy('desc')">
              <i class="fas fa-caret-down"></i>
            </div>
          </div>
        </div>
        <div class="td" style="flex-grow: 2">Tipo Corda</div>
        <div class="td" style="flex-grow: 2">Spina</div>
        <div class="td">H Spina</div>
        <div class="td" style="flex-grow: 2" v-if="isLever">Capotasto</div>
        <div class="td" v-if="isLever">H Capotasto</div>
        <div class="td" style="flex-grow: 2" v-if="isLever">Levetta</div>
        <div class="td" style="flex-grow: 2">Boccola</div>
        <div class="td">Revisione</div>
      </div>
      <section>
        <div class="tr justify-center">
          <button class="p-2 hover:text-aitems-700"
                  v-tooltip="'Aggiungi Una Corda'"
                  @click="addString(true)"
          >
            <i class="fas fa-plus-circle fa-3x"></i>
          </button>
        </div>
        <div class="row"
             v-for="(configuration, index) in table.configurations"
             :key="configuration.id"
        >
          <single-string :dataset="configuration"
                         :revision="revisione"
                         :is-lever="isLever"
          >

          </single-string>
        </div>
        <div class="tr justify-center">
          <button class="p-2 hover:text-aitems-700"
                  v-tooltip="'Aggiungi Una Corda'"
                  @click="addString(false)"
          >
            <i class="fas fa-plus-circle fa-3x"></i>
          </button>
        </div>
      </section>

    </section>
  </div>

</template>

<script>

import SingleString from './single-string/SingleString.vue';

export default {
  provide() {
    return {
      stringsLayoutState: this.sharedState
    }
  },

  props: ['configurations', 'revisione', 'id', 'is-lever', 'r-action'],

  components: {SingleString},

  data() {
    return {
      table: new Table({
        configurations: this.configurations
      }),
      actions: [],
      selectedAction: this.rAction,
      reverse: false,
      isActive: false,
      isEditorActive: false,
      layoutToBeEdit: 'dummy',
      sharedState: {
        activeRow: this.configurations[0].position
      }
    }
  },

  created() {
    this.orderBy();
    this.getActions()
  },

  methods: {

    orderBy(ord = 'asc') {
      this.table.configurations = _.orderBy(this.table.configurations, 'position', ord)
    },

    getActions() {
      if (!this.isLever) {
        axios.get('/items?type=MECCANICHE')
            .then(({data}) => {
              this.actions = data;
            })
      }
    },

    updateAction() {
      axios.patch(`/strings-layouts/${this.id}/action`, {selectedAction: this.selectedAction})
          .then(() => {
            console.log('Action Updated')
          })
    },

    publish() {
      swal.fire({
        title: 'T\'è propi sicur?',
        text: "Stai per pubblicare una nuova revisione!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si! Pubblica!',
      })
          .then(({value}) => {
            if (value) {
              axios.get('/strings-layouts/' + this.id + '/publish')
                  .then(() => {
                    location.href = '/strings-layouts/';
                  });
            } else {
              console.log('Mi sono dismesso tutto!');
            }
          });
    },

    addString(first) {
      swal.fire({
        title: 'T\'è propi sicur?',
        text: "Vuoi davvero aggiungere una Corda (alla fine)",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si! Aggiungi!'
      })
          .then(({value}) => {
            if (value) {
              axios.post(`/strings-layouts/${this.id}/add-string`, {first: first})
                  .then(({data}) => {

                    this.table.configurations.push(data);
                    this.sharedState.activeRow = data.position;

                    this.orderBy();
                  });
            } else {
              console.log('Mi sono dismesso tutto!');
            }
          });

    }
  },

}
</script>

<style lang="scss">

</style>